(function() {
    var suggestions = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        // prefetch: '../data/films/post_1960.json',
        remote: {
            url: '/api/suggestion/search/%QUERY',
            wildcard: '%QUERY',
            cache: false
        }
    });

    $('.offerSearch').typeahead(null, {
        source: suggestions,
        highlight: true,
        hint: true,
        minLength: 2,
        order: "asc",
        name: 'offers',
        display: 'name',
        limit: 10,
        templates: {
            empty: '<div class="col-md-12 no-results">No Result Found</div>',
            suggestion: function(suggestion) {
                if(suggestion.type == 'offer')
                    return '<div class="col-md-12 "><a href="/offers/all/all/all/all/'+suggestion.offerSlug+'/all/popular"><div >'+suggestion.name+'<b class="pull-right">Offer</b></div></a></div>';
                if(suggestion.type == 'brand')
                    return '<div class="col-md-12 "><a href="/offers/all/all/'+suggestion.brandSlug+'/all/all/all/popular"><div >'+suggestion.name+'<b class="pull-right">Brand</b></div></a></div>';
                if(suggestion.type == 'branch')
                    return '<div class="col-md-12 "><a href="/offers/all/all/all/'+suggestion.branchSlug+'/all/all/popular"><div >'+suggestion.name+'<b class="pull-right">Store</b></div></a></div>';
                if(suggestion.type == 'category')
                    return '<div class="col-md-12 "><a href="/offers/'+suggestion.categorySlug+'/all/all/all/all/all/popular"><div >'+suggestion.name+'<b class="pull-right">Category</b></div></a></div>';
            }
        }
    }).on('typeahead:selected', function(e){
        window.location = '/offers/all/all/all/all/all/'+encodeURIComponent($(this).typeahead('val'))+'/popular';
    });

    $('.offerSearchForm').on('submit', function(e){
        e.preventDefault();
        if(!$('#offerSearch').typeahead('val'))
        {
            swal({
                title: "Alert!!!",
                text: "Please enter keywords for search.",
                timer: 1000,
                showConfirmButton: false
            });
        }
        else
        {
            window.location = '/offers/all/all/all/all/all/'+encodeURIComponent($('#offerSearch').typeahead('val'))+'/popular';
        }
    });
})();